import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  KEY_ALIGN as pluginKey,
  isCollapsed,
  setAlign,
  someNode,
} from '@udecode/plate';
import { focusEditor, useEditorRef, useEventPlateId } from '@udecode/plate-common';

import { ToolbarButton } from './ToolbarButton';

export const AlignmentButtons = ({ ...props }) => {
  const editor = useEditorRef(useEventPlateId());

  return (
    <>
      <AlignmentButton
        name="Align left"
        value="left"
        icon={<FontAwesomeIcon icon={['fa', 'align-left']} />}
        editor={editor}
        {...props}
      />
      <AlignmentButton
        name="Align center"
        value="center"
        icon={<FontAwesomeIcon icon={['fa', 'align-center']} />}
        editor={editor}
        {...props}
      />
      <AlignmentButton
        name="Align right"
        value="right"
        icon={<FontAwesomeIcon icon={['fa', 'align-right']} />}
        editor={editor}
        {...props}
      />
      <AlignmentButton
        name="Justify"
        value="justify"
        icon={<FontAwesomeIcon icon={['fa', 'align-justify']} />}
        editor={editor}
        {...props}
      />
    </>
  );
};

const AlignmentButton = ({ editor, icon, value, name, ...props }) => {
  const active =
    isCollapsed(editor?.selection) &&
    someNode(editor, { match: { [pluginKey]: value } });

  const setEditorAlignment = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAlign(editor, { value, key: pluginKey });
    setTimeout(() => {
      focusEditor(editor);
    }, 0);
  };

  return (
    <ToolbarButton
      name={name}
      icon={icon}
      onClick={setEditorAlignment}
      active={active}
      {...props}
    />
  );
};
